import React from 'react';
import {Button, Divider} from "@mantine/core";
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Mission2 from "@/app/(index)/mission/mission";


export default function MissionPC() {
    const { fontSize, lang } = useGlobalStateStore();
    return (
        <div className="flex flex-col gap-6 mt-[50px]">
            <div className="flex gap-10">
                <div><Mission2 iconIndex={1}/></div>
                <div className="flex flex-col gap-3 flex-1">
                    <div className="text-[#458481] text-[20px] font-black">
                        {lang == "tw" ? "支援政府科技政策規劃" : "To support the government on S&T policy planning"}
                    </div>
                    <div className="text-xl text-justify">
                        {
                            lang == "tw" ? "科政中心致力於建構以證據為基礎，具快速回應議題能力的智庫，以支援政府科技決策。中心長期聚焦我國科技部會及產學研界關切的科技政策關鍵議題，進行新興趨勢之觀測與研析，同時槓桿國內外專業領域合作網絡，促進知識交流，並培育跨領域科技政策研究人才，以提升科技政策論述能力並強化研究能量。"
                                : "STPI is dedicated to building an evidence-based think tank with the capacity to respond swiftly to emerging issues, in order to support government decision-making in science and technology. STPI has long focused on key S&T policy issues of concern to Taiwan’s government agencies, academia, and industry. It conducts research and analysis on emerging trends, leverages domestic and international professional networks to promote knowledge exchange, and cultivates interdisciplinary talent in S&T policy research to enhance policy discourse and strengthen research capabilities."
                        }
                    </div>
                    {
                        lang == "en" && (
                            <div className="flex gap-3">
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/A"}>
                                    Policy Research Division
                                </Button>
                            </div>
                        )
                    }
                </div>

                {
                    lang == "tw" && (
                        <div className="flex flex-col items-center justify-center gap-3 w-[120px] ">
                            <Button color="#b19d58" radius="xl" component="a" href={"/group/A"}>
                                政策研究組
                            </Button>
                        </div>
                    )
                }
            </div>

            <Divider color="#cedbdc" variant={"dotted"}/>

            <div className="flex gap-10">
                <div><Mission2 iconIndex={3}/></div>
                <div className="flex flex-col gap-3 flex-1">
                    <div className="text-[#458481] text-[20px] font-black">
                        {lang == "tw" ? "協助科技計畫審評與管理" : "To assist the government in evaluation and management of S&T programs"}
                    </div>
                    <div className="text-xl text-justify">
                        {
                            lang == "tw" ? "科政中心長年協助國科會建置全方位資訊平台以強化科技計畫治理能量並優化治理循環，落實科技計畫全生命週期資料整合，近年並導入智慧化輔助工具提升計畫資料分析品質與服務效能，以資訊系統搭配幕僚服務有效支援計畫審議、執行管考及績效評估作業。另亦持續進行國際科技政策趨勢追蹤、研析重大科技議題及其對我國社經發展之影響，並維運我國科技人才及政策研究指標資料庫，以供政府部會與學研單位運用。"
                                : "Over the years, STPI has supported the National Science and Technology Council (NSTC) in developing a comprehensive information platform to enhance the governance of S&T programs and optimize the governance cycle. This includes integrating full life-cycle data of S&T programs, and in recent years, incorporating intelligent tools to improve the quality of program data analysis and service efficiency. By combining information systems with expert support services, STPI effectively assists in program review, execution monitoring, and performance evaluation. In addition, STPI continues to track international trends in S&T policy, analyze major science and technology issues and their impact on Taiwan’s socioeconomic development, and maintain key indicator databases on Taiwan’s S&T talent and policy research to support government agencies, academic institutions, and research organizations."
                        }
                    </div>
                    {
                        lang == "en" && (
                            <div className="flex gap-3">
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/B"}>
                                    Databases & Information Services Division
                                </Button>
                            </div>
                        )
                    }
                </div>
                {
                    lang == "tw" && (
                        <div className="flex flex-col items-center justify-center gap-3 w-[120px] ">
                            <Button color="#b19d58" radius="xl" component="a" href={"/group/B"}>
                                科研資料組
                            </Button>
                        </div>
                    )
                }
            </div>
            <Divider color="#cedbdc" variant={"dotted"}/>

            <div className="flex gap-10">
                <div><Mission2 iconIndex={5}/></div>
                <div className="flex flex-col gap-3 flex-1">
                    <div className="text-[#458481] text-[20px] font-black">
                        {lang == "tw" ? "提供學術資訊資源服務" : "To provide integrated information services"}
                    </div>
                    <div className="text-xl text-justify">
                        {
                            lang == "tw" ? "科政中心藉由「全國學術電子資訊資源共享聯盟」（CONCERT）之運作， 協助全國學術機構引進國內外電子資訊資源，推展學術電子資訊資源之合理取得與使用，以建構優質研究發展與教學基礎設施。同時亦維運「全國文獻傳遞服務系統」（NDDS）服務，結合聯合目錄、帳務結算等機制，成為全國學研機構圖書館書刊資訊資源合作分享之重要樞紐，節省國家書刊購置經費及人力，並提升資訊服務效率及品質。"
                                : "Core responsibilities include providing comprehensive academic information services to alliance members—including universities, research institutions, and government agencies—through platforms such as CONCERT and NDDS."
                        }
                    </div>
                    {
                        lang == "en" && (
                            <div className="flex gap-3">
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/B/e1a9bb82-6a6c-4f80-8eb0-9230570569af"}>
                                    Databases & Information Services Division
                                </Button>
                            </div>
                        )
                    }
                </div>
                {
                    lang == "tw" && (
                        <div className="flex flex-col items-center justify-center gap-3 w-[120px] ">
                            <Button color="#b19d58" radius="xl" component="a" href={"/group/B/e1a9bb82-6a6c-4f80-8eb0-9230570569af"}>
                                科研資料組
                            </Button>
                        </div>
                    )
                }
            </div>
            <Divider color="#cedbdc" variant={"dotted"}/>

            <div className="flex gap-10">
                <div><Mission2 iconIndex={2}/></div>
                <div className="flex flex-col gap-3 flex-1">
                    <div className="text-[#458481] text-[20px] font-black">
                        {lang == "tw" ? "支援政府科技產業發展" : "To support the government on the development of S&T industry"}
                    </div>
                    <div className="text-xl text-justify">
                        {
                            lang == "tw" ? "科政中心建構脈絡化、結構化與系統化之整合性科技策略規劃機制，完善前瞻議題研析方法與工具，並透過新興科技資料庫系統化數據基礎與AI工具導入，強化科技產業發展之創新策略規劃與政策支援，以協助政府部會研擬具可行性創新政策。此外，為支援跨部會科技政策之整合與推動，提升政策的可行性及可信賴性，亦建立跨部會、跨機構與跨領域主題式專家名單及串聯國內外產學研交流網絡，作為即時性議題研析、國際接軌及政策溝通重要輔助系統。"
                                : "STPI has established an integrated S&T strategic planning mechanism that is contextualized, structured, and systematized. It has also refined methodologies and tools for analyzing forward-looking issues. By leveraging systematized data from emerging technology databases and incorporating AI tools, STPI strengthens the planning of innovative strategies and provides policy support for the development of S&T industries, assisting government agencies in formulating feasible and innovative policies. Furthermore, to support the integration and implementation of cross-ministerial S&T policies and to enhance their feasibility and credibility, STPI has developed expert rosters organized by thematic areas across ministries, institutions, and disciplines. It also connects domestic and international academic, industrial, and research networks, serving as a vital support system for real-time policy analysis, international alignment, and policy communication."
                        }
                    </div>

                    {
                        lang == "en" && (
                            <div className="flex gap-3">
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/C"}>
                                    S&T Industry Division
                                </Button>
                            </div>
                        )
                    }

                </div>
                {
                    lang == "tw" && (
                        <div className="flex flex-col items-center justify-center gap-3 w-[120px] ">
                            <Button color="#b19d58" radius="xl" component="a" href={"/group/C"}>
                              科產推動組
                            </Button>
                        </div>
                    )
                }

            </div>
            <Divider color="#cedbdc" variant={"dotted"}/>

            <div className="flex gap-10 flex-1">
                <div><Mission2 iconIndex={4}/></div>
                <div className="flex flex-col gap-3">
                    <div className="text-[#458481] text-[20px] font-black">
                        {lang == "tw" ? "促進學研創新生態系發展" : "To activate the innovation eco-system of R&D achievements"}
                    </div>
                    <div className="text-xl text-justify">
                        {
                            lang == "tw" ? "科政中心進行以國內外產創資料為基礎的研究並提出創新方案，以AI工具平台鏈結多元利害關係人且持續推動創新人才培育，同時協助國科會研擬科研成果商品化機制之政策規劃、推動與建議，以促進學研能量及研究成果有效與產業對接，提升產業創新並健全我國創新生態系發展。同時為協助國科會達成攸關國家科技發展的「科技人才培育」任務，科政中心聚焦培養具跨領域整合與商品化實務能力的生醫轉譯人才，作為學研成果邁向商業應用與創業發展的基礎驅動力。"
                                : "STPI conducts research based on domestic and international data related to industrial innovation and development, proposing innovative solutions and leveraging AI platforms to connect diverse stakeholders while continuously promoting the cultivation of innovation talent. STPI also supports the National Science and Technology Council (NSTC) in the planning, implementation, and policy recommendations for mechanisms that facilitate the commercialization of research outcomes, aiming to strengthen the linkage between academic research capabilities and industry needs, and foster the development of a robust innovation ecosystem in Taiwan. In parallel, to support the NSTC’s mission of cultivating S&T talent, STPI focuses on nurturing biomedical translational professionals equipped with interdisciplinary integration and commercialization skills, serving as a foundational driving force for advancing academic research toward commercial application and entrepreneurial growth."
                        }
                    </div>

                    {
                        lang == "en" && (
                            <div className="flex gap-3">
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/D"}>
                                    Innovation & Entrepreneurship Promotion Division
                                </Button>
                                <Button color="#b19d58" radius="xl" component="a" href={"/group/C"}>
                                    S&T Industry Division
                                </Button>
                            </div>
                        )
                    }

                </div>
                {
                    lang == "tw" && (
                        <div className="flex flex-col items-center justify-center gap-3 w-[120px]">
                            <Button color="#b19d58" radius="xl" component="a" href={"/group/C"}>
                                科產推動組
                            </Button>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
